<template>
  <a-form
    :form="form"
    @submit="save"
    class="pop-common-form"
    :style="{width: '700px', margin: '0 auto'}">
    <a-form-item
      class="form-item"
      v-bind="formItemLayout"
      hasFeedback>
      <template slot="label">
        <span class="">B账号</span>
      </template>
      <Input
        :value="userInfo && userInfo.userName"
        disabled
      />
    </a-form-item>
    <a-form-item
      class="form-item"
      v-bind="formItemLayout"
      hasFeedback>
      <template slot="label">
        <span class="required">昵称</span>
      </template>
      <Input
        placeholder="请输入昵称"
        v-model="form.name.value"
        disabled
      />
    </a-form-item>
    <a-form-item
      class="form-item"
      v-bind="formItemLayout"
      :validate-status="form.newPhone.validateStatus"
      :help="form.newPhone.help"
      hasFeedback>
      <template slot="label">
        <span class="required">新手机号</span>
      </template>
      <Input
        maxlength="11"
        placeholder="请输入新的手机号"
        v-model="form.newPhone.value"
        @change="validateHandler('newPhone', $event)"
      />
    </a-form-item>
    <Sendmobile
      :phone="form.newPhone.value"
      :value.sync="form.newCode.value"
      :validateStatus="form.newCode.validateStatus"
      :help="form.newCode.help"
      :isSendCode.sync = "isSendCode"
      service-type="PWD"
      @resetCode="getNewCode"
      @checkCode="checkCode"
    />
    <a-form-item
      class="form-item"
      label=" "
      v-bind="formItemLayout">
      <Button class="op-btn" type="primary" @click="save" :disabled="isDisabled">保存</Button>
      <Button class="op-btn" @click="prev">上一步</Button>
    </a-form-item>
  </a-form>
</template>

<script>
  import { Input, Button } from 'ant-design-vue'
  import form from "../../../shared/utils/form";
  import vuexMapper from '@mixins'
  import Sendmobile from "../../../shared/components/sendsms/sendmobile";
  import {$http} from "../../../shared/utils";
  import api from "../../../shared/utils/api";
  import CheckVcodeParam from "../classes/checkVcodeParam";
  import ModifyPhoneParam from "../classes/modifyPhoneParam";
  export default {
    name: "twoStep",
    components: {
      Sendmobile,
      Input,
      Button
    },
    mixins: [ form, vuexMapper ],
    props: {
      form: {
        type: Object
      }
    },
    watch: {
      userInfo: {
        immediate: true,
        handler ({ nickName }) {
          if (!nickName) {
            this.$router.go(-1)
          }
        }
      },
        form: {
            handler: function (newForm) {
                this.isDisabled = ['newPhone','newCode'].some(key => {
                    return !newForm[key].value
                })
            },
            deep: true
        }
    },
    data () {
      return {
        isSendCode: false,
          isDisabled:true
      }
    },
    methods: {
      async getNewCode() {
        // this.validateFields(['newPhone'] 状态校验
        if (await this.validateFields(['newPhone'])) {
          this.isSendCode = true
        } else {
          this.isSendCode = false
        }
      },
      checkCode() {
        // 校验验证码一栏是是否正确
        this.validateFields(['newCode'])
      },
      prev () {
        this.form.newPhone.value = ''
        this.form.newPhone.validateStatus = ''
        this.form.newPhone.help = ''
        this.form.newCode.value = ''
        this.form.newCode.validateStatus = ''
        this.form.newCode.help = ''
        this.$emit('change', 'OneStep')
      },
      async modifyPhone (param) {
        const {code , msg} = await $http.get(`${api.mainHost}${api.mainContentPath}/account/modifyPhone.do`,{
          params: {
            param
          }
        })
        if (code * 1 === 1) {
          this.$message.success('修改成功！')
          this.$router.push({ name: 'safe' })
        } else {
          this.$message.error(msg)
        }
      },
      async save () {
        const { userInfo } = this
        if (userInfo) {
          const valid = await this.validateFields(['newPhone', 'newCode'])
          const checkVcodeParam = new CheckVcodeParam(this.form.newPhone.value, this.form.newCode.value)
          if (valid) {
            this.modifyPhone(JSON.stringify(new ModifyPhoneParam(checkVcodeParam, userInfo.userName)))
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
